<template>
  <div class="container">
    <div class="info">
      <div class="tit">{{ $t('finance').financeOrderList }}</div>
      <!-- 列表 -->
      <div class="listInfo">
        <!-- 产品标题 -->
        <div class="title">
          <div class="name">{{ $t('market').product }}</div>
          <span>{{ $t('finance').term }}</span>
          <span>{{ $t('finance').investment }}</span>
          <span>{{ $t('finance').EstimatedReturn }}</span>
          <span>{{ $t('finance').Subscriptiondate }}</span>
          <span>{{ $t('finance').duedate }}</span>
        </div>
        <van-list v-model="loading" :finished="finished" :loading-text="$t('public').loadingText" @load="getFinanceOrderList" :immediate-check="false">
          <div class="item" v-for="(dItem, dIndex) in oList" :key="`fiorder${dIndex}`" @click="$router.push({ name: 'FinanceOrderInfo', query: { id: dItem.financingOrderId } })">
            <div class="name">{{ dItem.name }}</div>
            <span>{{ dItem.yieldDays }} {{ $t('finance').day }}</span>
            <span>{{ dItem.amount }} USDT</span>
            <span v-if="dItem.status==1">{{ (dItem.amount*dItem.yieldMin/100*dItem.yieldDays).toFixed(6).replace(/\.?0+$/, '') }} USDT</span>
            <span v-if="dItem.status==3">{{ dItem.revenueAmount }} USDT</span>
            <span>{{ dItem.applyTime | getLocalTime }}</span>
            <span v-if="dItem.status==1">{{ dItem.maturityTime | getLocalTime }}</span>
            <span v-if="dItem.status==3">{{ $t('c2c').Completed }}</span>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import orderApi from '@/api/order'
export default {
  data() {
    return {
      isRun: false,
      loading: false,
      finished: false,
      parms: {
        pageNum: 1,
        pageSize: 15,
      },
      oList: [],
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    this.getFinanceOrderList()
  },
  methods: {
    // 获取理财订单记录
    async getFinanceOrderList() {
      if (this.isRun) return
      this.isRun = true
      const res = await orderApi.getFinanceOrderList(this.parms)
      this.oList.push(...res.rows);
      this.isRun = false
      this.parms.pageNum++
      // 加载状态结束
      this.loading = false;
      // 数据全部加载完成
      if (this.oList.length >= res.total)
        this.finished = true;
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  padding-top: 110px;
  width: 100%;
  background: var(--background_color);

  .info {
    margin: 0 auto;
    max-width: 1280px;

    .tit {
      font-size: 36px;
      font-weight: bold;
      color: var(--text_color);
    }

    .listInfo {
      margin-top: 20px;
      .title {
        padding: 0 15px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: var(--ntext_color);
        font-size: 14px;
        height: 50px;
        border-bottom: 1px solid var(--info_color);

        .name {
          width: 30%;
          text-align: left;
        }

        span {
          width: 14%;
          text-align: right;
        }
      }

      .item {
        padding: 30px 15px;
        border-bottom: 1px solid var(--info_color);
        display: flex;
        align-items: center;
        justify-content: space-between;

        &:hover {
          background: var(--info_color);
        }

        .name {
          width: 30%;
          font-size: 17px;
          font-weight: bold;
          color: var(--text_color);
        }

        span {
          font-size: 14px;
          color: var(--text_color);
          width: 14%;
          text-align: right;
        }
      }
    }

    .orderInfo {
      padding: 30px;

      .name {
        font-size: 18px;
        font-weight: bold;
        color: var(--text_color);
        display: flex;
        align-items: center;

        span {
          margin-left: 10px;
          font-size: 13px;
          font-weight: normal;
        }
      }

      .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 30px;
        font-size: 15px;
        color: var(--ntext_color);

        span {
          color: var(--text_color);
        }
      }
    }
  }
}

::v-deep .van-popup--bottom {
  border-radius: 15px 15px 0 0;
  background: var(--background_color);
}

::v-deep .van-popup--center {
  border-radius: 15px;
  background: var(--info_color);
}

::v-deep .van-popup__close-icon {
  font-size: 18px;
  color: var(--ntext_color);
}
</style>
